import { IconButton } from 'bimui';
import { EngineContext, NavigationContext, RegisterContext } from '@/App'
import React, { useContext, useEffect, useRef, useState } from 'react'
import { ReactComponent as CloseSvg } from 'bimui/dist/c1/icons/cancel.svg'
import { ReactComponent as ExpandSvg } from './icons/expand.svg'
import { ReactComponent as CollapseSvg } from './icons/collapse.svg'
import './index.less'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { coreAxios } from '@/declare/api/axios';
import { emitter } from '@/utils/mitt';
import { Emit_Event_Common_Tool } from '@/declare/enums/emit-event';
import classNames from 'classnames'; // 引入 classnames 库
import localStore from '@/store/local-store';
import { PythaEventSetting, SETTING_KEY, UpdateType } from 'pytha2';
import { SIDEBAR_TYPE } from '@/declare/enums/menu-type';
/**
 * 侧边栏
 * @returns 
 */
export default function MainSidebar() {
    const navigate = useNavigate();
    const routeParams = useParams();
    const location = useLocation();
    const { projectUuid, modelUuid } = useParams();
    // 注册存储
    const registerContext = useContext(RegisterContext);
    const engineContext = useContext(EngineContext); // 获取上下文
    // 导航存储
    const navigateContext = useContext(NavigationContext);
    const { isSidebarCollapsed, setSidebarCollapsed } = registerContext; // 获取全局的状态和方法
    const [isTransitioning, setIsTransitioning] = useState(false); // 控制过渡状态
    const [sidebarPanelInitStatus, setSidebarPanelInitStatus] = useState<{}>({});

    /**
     * 拿到面板的缓存状态
     */
    useEffect(() => {
        if (registerContext.currentActivedSidebarKey == null) return;
        const status = localStore.getSidebarStatus(registerContext.currentActivedSidebarKey);
        setSidebarPanelInitStatus(status);
    }, [registerContext.currentActivedSidebarKey])

    // 当前激活的侧边栏
    const ActiveSidebar = registerContext.sidebarPanels[registerContext.currentActivedSidebarKey];


    useEffect(() => {
        if (registerContext.currentActivedSidebarKey == null) return;
        // 侧边栏发生变化，更新tabs
        let tabs = localStore.getTabsBySidebarKey(registerContext.currentActivedSidebarKey);
        let activeTabKey = localStore.getActiveTabKeyBySidebarKey(registerContext.currentActivedSidebarKey);
        if (registerContext.currentActivedSidebarKey == SIDEBAR_TYPE.BLOCK) {
            // 先过滤掉tabs里包含model路由的页签，避免重复
            tabs = tabs.filter(tab => !tab.key.includes('/models/'));
            if (location.pathname.includes('/models/')) {
                // 如果是块的侧边栏，需要把模型的页签也拿过来
                const modelTabs = localStore.getTabsBySidebarKey(SIDEBAR_TYPE.MODEL);
                tabs.push(...(modelTabs || []));
                activeTabKey = window.location.pathname;
            }
        }
        navigateContext.setTabs(tabs);
        if (activeTabKey != null) {
            navigate(activeTabKey);
            navigateContext.setActiveTabKey(activeTabKey);
        } else {
            if (registerContext.sidebarPanels[registerContext.currentActivedSidebarKey] != null) {
                // 侧边栏不是空，是打开了一个侧边栏，不是打开一个页签
                if (projectUuid != null) {
                    navigate(`/projects/${projectUuid}`);
                } else {
                    navigate(`/system-lib`);
                }
            }
        }
    }, [registerContext.currentActivedSidebarKey])

    if (registerContext?.currentActivedToolKey != null || ActiveSidebar == null) {
        // 隐藏侧边栏
        if (engineContext.engine) {
            // 调整画布 防止画布有一块黑色
            let event = new PythaEventSetting();
            event.data = {
                key: SETTING_KEY.CANVAS_RESIZE,
                value: true,
            }
            setTimeout(() => {
                engineContext.engine.eventMediator.emitEvent(event)
            }, 0);
        }
        return null;
    }

    const handleCollapseToggle = () => {
        setIsTransitioning(true); // 开启过渡状态
        setSidebarCollapsed(!isSidebarCollapsed); // 更新全局状态
        setTimeout(() => setIsTransitioning(false), 300); // 300ms后关闭过渡状态（与CSS动画时间一致）
    };

    return (
        <div
            className={classNames('main-sidebar-container', {
                collapsed: isSidebarCollapsed,
            })}
        >
            {/* 收起/展开按钮 */}
            <div
                className={classNames('collapse-expand-btn', {
                    'outside': isSidebarCollapsed, // 当收起时增加 outside 样式
                    'hidden': isTransitioning, // 过渡期间隐藏按钮
                })}
                onClick={handleCollapseToggle}
            >
                {isSidebarCollapsed ? <ExpandSvg /> : <CollapseSvg />}
            </div>

            {/* 关闭按钮 */}
            {/* <IconButton
                wrapClassName="close-icon"
                small
                icon={<CloseSvg />}
                onClick={() => {
                    registerContext.activeSidebar(null);
                }}
            /> */}
            <IconButton wrapClassName='close-icon' small icon={<CloseSvg />} onClick={() => {
                registerContext.activeSidebar(null);
            }}></IconButton>
            {/* 展开时不重新加载，侧边栏仅仅是变成了隐藏状态 */}
            {(
                <div
                    className={classNames('active-sidebar-content', {
                        hidden: isSidebarCollapsed, // 当收起时增加隐藏样式
                    })}
                >
                    <ActiveSidebar
                        {...engineContext}
                        projectUuid={projectUuid}
                        axios={coreAxios}
                        emitter={emitter}
                        emitterType={Emit_Event_Common_Tool}
                        navigate={(key) => navigate(key)}
                        currentActivedSidebarKey={registerContext.currentActivedSidebarKey}
                        currentActivedToolKey={registerContext.currentActivedToolKey}
                        activeSidebarPanel={(key: string) => {
                            registerContext.activeSidebar(key);
                        }}
                        routeParams={routeParams}
                        panelInitStatus={sidebarPanelInitStatus}
                        onStatusChange={(status) => {
                            localStore.setSidebarStatus(registerContext.currentActivedSidebarKey, status);
                        }}
                    />
                </div>
            )}

        </div>
    )
}
